import axios from "axios";
import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";
import { baseURLTemporaryWebhook, integrationKeyTemporaryWebhook }  from "../configuration";

const api = new API();

export default class UserController 
{
    async create(data) 
    {
        const response = await api.user().post(data);
        return apiCallbackTreatment(response);
    }

    async get(userId = null) 
    {
        const response = await api.user().get(userId);
        return apiCallbackTreatment(response);
    }

    async getAllSpecialistByUnitCompany(idCompanyUnit) 
    {
        const response = await api.user().getAllSpecialistByUnitCompany(idCompanyUnit);
        return apiCallbackTreatment(response);
    }

    async getAllUsersByCompanyUnit(idUserLogged, status = null) 
    {
        const response = await api.user().getAllUsersByCompanyUnit(idUserLogged, status);
        return apiCallbackTreatment(response);
    }

    async getManagerOfCompanyUnit(idCompanyUnit) 
    {
        const response = await api.user().getManagerOfCompanyUnit(idCompanyUnit);
        return apiCallbackTreatment(response);
    }

    async getManagerOfCompaniesUnits(idsCompaniesUnits) 
    {
        const response = await api.user().getManagerOfCompaniesUnits(idsCompaniesUnits);
        return apiCallbackTreatment(response);
    }

    async getSpecialistOfCompaniesUnits(idCompanyUnit) 
    {
        const response = await api.user().getSpecialistOfCompaniesUnits(idCompanyUnit);
        return apiCallbackTreatment(response);
    }

    async getById(id) 
    {
        const response = await api.user().getById(id);
        return apiCallbackTreatment(response);
    }

    async getOwnersForUserOnAccess(id) 
    {
        const response = await api.user().getOwnersForUserOnAccess(id);
        return apiCallbackTreatment(response);
    }
    
    async update(id, data) 
    {
        const response = await api.user().update(id, data);
        return apiCallbackTreatment(response);
    }
    
    async changeAvatar(data, id) 
    {
        const response = await api.user().changeAvatar(data, id);
        return apiCallbackTreatment(response);
    }

    async getAvatar(id) 
    {
        const response = await api.user().getAvatar(id);
        return apiCallbackTreatment(response);
    }

    async hasAvatar(id) 
    {
        const response = await api.user().hasAvatar(id);
        return apiCallbackTreatment(response);
    }

    async getUsersERPTemporaryWebhook()
    {
        let response = await axios.get(`${baseURLTemporaryWebhook}/user/all/key=${integrationKeyTemporaryWebhook}`);
        response = response.data;
        return apiCallbackTreatment(response);
    }
}